import { render, staticRenderFns } from "./betfinder.vue?vue&type=template&id=c9e099e8&scoped=true"
import script from "./betfinder.vue?vue&type=script&lang=js"
export * from "./betfinder.vue?vue&type=script&lang=js"
import style0 from "./betfinder.vue?vue&type=style&index=0&id=c9e099e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e099e8",
  null
  
)

export default component.exports